/**
 *
 * @param x0 - First point
 * @param x1 - Second point
 * @returns The distance between the two points in a circumference
 */
export function distanceBetweenTwoPoints(
  x0: number,
  x1: number,
  y0: number,
  y1: number,
) {
  return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
}
